import { Heading, Text, Button, Image } from '@bq/web-components';
import styles from './HeroSection.module.css';

export interface HeroSectionProps {
  onSignUp?: () => void;
}

export function HeroSection({ onSignUp }: HeroSectionProps) {
  return (
    <section data-crd-id="r4.bq-hero-section" data-crd-layer="r4" className={styles.hero}>
      <video
        className={styles.videoBg}
        autoPlay
        muted
        loop
        playsInline
        src="/assets/video/hero-bg.mp4"
      />
      <div className={styles.container}>
        <div className={styles.headline}>
          <h5 className={styles.eyebrow}>Be like water my friend</h5>
          <Heading level={2} color="n000">
            Empowering One to be Many
          </Heading>
        </div>
        <div className={styles.block}>
          <div className={styles.body}>
            <Text size="r1" color="n000">
              We believe that each dev should be endowed with ninja-like super
              powers so that you can get sh*t done and live your best life!
            </Text>
            <Text size="r1" color="n000">
              What are these super powers?{' '}
              In short, they&apos;re a collaboration of you and BlueQueue AI.
            </Text>
            <div className={styles.ctas}>
              <Button variant="primary" size="large" onClick={onSignUp}>
                Sign Up
              </Button>
              <Button variant="secondaryLight" size="large" href="#solution">
                Learn More
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.graphic}>
        <Image
          src="/assets/images/ninja-sword-no-mtgs.png"
          alt="A blue ninja posing with a sword and saying. No more meetings!"
          width={700}
        />
      </div>
      <div className={styles.fade} />
    </section>
  );
}
